// https://opendocs.alipay.com/open/025a4p
// https://myjsapi.alipay.com/alipayjsapi/index.html

// import "@lib/third/alipayjsapi.min.js";
// import "@lib/third/alipayjsapi-3.1.1.inc.min.js";

/**
 * 信鸽停车支付宝生活号
 * appid
 *
 * 卓能支付宝生活号
 * appid
 *
 * 信鸽停车支付宝小程序
 * appid  2019021863245748
 *
 * 卓能支付宝小程序
 * appid  2021001108622239
 */

// eslint-disable-next-line @typescript-eslint/no-namespace
declare namespace AlipayJSBridge {
  function call(method: string, ...args: any[]): void;
}

type commonFailOption = { error: number; errorMessage: string };

type commonOption = {
  success?: () => void;
  fail?: (res: commonFailOption) => void;
  complete?: () => void;
};

type tradePayOption = {
  tradeNO?: string; // 交易号，多个交易号请用英文分号;分隔
  partnerID?: string; // 商户id
  bizType?: string; // 交易类型，默认为 ‘trade’
  bizSubType?: string; // 交易子类型
  bizContext?: string; //	支付额外的参数，格式为JSON字符串
  orderStr?: string; //	完整的支付参数拼接成的字符串，从服务端获取。需要入驻蚂蚁金服开放平台
};

type scanOption = {
  type?: "qr" | "bar"; // 扫描目标类型，支持 qr / bar，相应扫码选框会不同，默认 qr
};

type getLocationOption = {
  cacheTimeout?: number; // 钱包经纬度定位缓存过期时间，单位秒。默认 30s。使用缓存会加快定位速度，缓存过期会重新定位
  type?: 0 | 1 | 2; // 支持 0：详细逆地理编码，带周边信息；1：逆地理编码到城市；2：仅获取经纬度、速度和精度。默认为 2
  timeout?: number; // 定位超时失败回调时间，单位秒。默认10s
  bizType?: number; // 自定义业务类型
};

type getLocationResult = {
  longitude: string; // 经度
  latitude: string; // 纬度
  accuracy: string; // 精度，单位米
  speed: string; // 速度，单位毫秒
  country?: string; // 国家名
  countryCode?: string; // 国家编号
  province?: string; // 省份名
  city?: string; // 城市名
  cityCode?: string; // 城市编码
  adCode?: string; // 区域编码
  streetNumber?: { street: string; number: number }; // 街道门牌信息
  pois?: { name: string; address: string }[]; // 定位点附近的 POI 信息
};

type openLocationOption = {
  longitude: string; // 经度
  latitude: string; // 纬度
  name?: string; // 位置名称
  address?: string; // 地址的详细说明
  scale?: number; // 缩放比例，范围3~19，默认为15
};

type chooseImageOption = {
  count?: number; //	最大可选照片数，默认1张，上限9张
  sourceType?: ["camera", "album"] | ["camera"] | ["album"]; //	相册选取或者拍照，默认 ['camera','album']
};

type chooseImageResult = {
  apFilePaths: string[]; // 图片文件路径
};

type previewImageOption = {
  urls: string[]; // 要预览的图片链接列表
  current?: number; // 当前显示图片索引，默认 0
};

// eslint-disable-next-line @typescript-eslint/no-namespace
declare namespace ap {
  function tradePay(
    option: tradePayOption & commonOption,
    complete: (res: {
      resultCode: number; // 支付结果状态码
    }) => void
  ): void;
  function scan(
    option: scanOption & commonOption,
    complete: (res: {
      code: string; // 扫码所得数据
    }) => void
  ): void;
  function getLocation(
    option: getLocationOption & commonOption,
    complete: (res: getLocationResult) => void
  ): void;
  function openLocation(
    option: openLocationOption & commonOption,
    complete?: () => void
  ): void;
  function chooseImage(
    option: chooseImageOption & commonOption,
    complete: (res: chooseImageResult) => void
  ): void;
  function previewImage(
    option: previewImageOption & commonOption,
    complete?: () => void
  ): void;
}

// 由于机制问题，JSAPI注入是异步过程，时序无法保证。
// 如果使用原生AlipayJSBridge接口，需要先监听AlipayJSBridgeReady事件后再调用原生JSAPI接口。
export function aliJsReady(callback: () => void) {
  // 如果jsbridge已经注入则直接调用
  if ((<any>window).AlipayJSBridge) {
    callback && callback();
  } else {
    // 如果没有注入则监听注入的事件
    document.addEventListener("AlipayJSBridgeReady", callback, false);
  }
}
// aliJsReady(function () {
//   AlipayJSBridge.call("toast", {
//     content: "hello"
//   });
// });

// 通过 Scheme 启动 支付宝生活号H5App
// 支付宝客户端的标准 Scheme 为：alipays://platformapi/startapp?appId=xxx
// 但如果是某些运营页之类的单独页面，没有自己的 APPID，可以使用Nebula容器的通用浏览器模式 appId=20000067 来启动，同时将需要打开的 H5 页面 URL 经过 encode 编码后设置到 URL 参数内，例如：alipays://platformapi/startapp?appId=20000067&url=http%3A%2F%2Fm.taobao.com

// 通过 JSAPI: startApp 接口启动 支付宝生活号H5App
// 可通过 closeCurrentApp 入参来同时关闭自身

// 退出 H5App 也存在两种情况：
// 第一种为当前 H5App 的窗口栈中的最后一个窗口也被销毁时，Nebula 容器会同时自动销毁掉这个 H5App实例。
// 第二种即为调用 JSAPI: exitApp 接口，可以在当前 H5App 下的任意一个 Window 窗口中调用，关闭一整个当前 H5App。

// H5 在 Nebula 容器中有多种页面跳转的方式，除了原生的 location.href / location.replace 之类的页面跳转方法以外，还有一个 JSAPI：pushWindow 接口。

function aliJsFormatCommonFailMessage(
  res: commonFailOption,
  methodName?: string
) {
  let errorCodeMessage = "未知错误";
  switch (res.error) {
    case 1:
      errorCodeMessage = "接口不存在";
      break;
    case 2:
      errorCodeMessage = "参数无效";
      break;
    case 3:
      errorCodeMessage = "发生未知错误";
      break;
    case 4:
      errorCodeMessage = "接口无权限";
      break;
    case 10:
      errorCodeMessage = "用户取消";
      break;
    case 11:
      errorCodeMessage = "操作失败";
      if (methodName === "chooseImage") {
        errorCodeMessage = "操作失败（权限不够）";
      }
      break;
    case 12:
      errorCodeMessage = "GPS打开，但定位失败";
      break;
    case 13:
      errorCodeMessage = "获取地理位置信息失败";
      break;
    case 14:
      errorCodeMessage = "定位超时";
      break;
    case 15:
      errorCodeMessage = "网络错误";
      break;
    case 16:
      errorCodeMessage = "GPS未打开或用户未授权";
      break;
  }
  return `${res.error}(${errorCodeMessage}): ${res.errorMessage}`;
}

// 发起支付
export function aliJsTradePay(
  option: tradePayOption,
  successCb?: (message: string) => void,
  errorCb?: (message: string) => void
) {
  ap.tradePay(
    Object.assign(option, {
      // fail: (res: commonFailOption) => {
      //   errorCb?.(aliJsFormatCommonFailMessage(res));
      // }
    }),
    function (res) {
      let resultMessage = "未知错误";
      switch (res.resultCode) {
        case 9000:
          resultMessage = "订单支付成功";
          return successCb?.(resultMessage);
        case 8000:
          resultMessage = "正在处理中";
          break;
        case 4000:
          resultMessage = "订单支付失败";
          break;
        case 6001:
          resultMessage = "用户中途取消";
          break;
        case 6002:
          resultMessage = "网络连接出错";
          break;
        case 99:
          resultMessage = "用户点击忘记密码导致快捷界面退出(only iOS)";
          break;
      }
      errorCb?.(resultMessage);
    }
  );
}

// 调用扫一扫功能
export function aliJsScan(
  option: scanOption,
  successCb?: (code: string) => void,
  errorCb?: (message: string) => void
) {
  ap.scan(
    Object.assign(option, {
      fail: (res: commonFailOption) => {
        errorCb?.(aliJsFormatCommonFailMessage(res));
      }
    }),
    function (res) {
      successCb?.(res.code);
    }
  );
}

// 获取当前的地理位置信息
export function aliJsGetLocation(
  option: getLocationOption,
  successCb?: (res: getLocationResult) => void,
  errorCb?: (message: string) => void
) {
  ap.getLocation(
    Object.assign(option, {
      fail: (res: commonFailOption) => {
        errorCb?.(aliJsFormatCommonFailMessage(res));
      }
    }),
    function (res) {
      successCb?.(res);
    }
  );
}

// 使用支付宝内置地图查看位置
export function aliJsOpenLocation(
  option: openLocationOption,
  successCb?: () => void,
  errorCb?: (message: string) => void
) {
  ap.openLocation(
    Object.assign(option, {
      fail: (res: commonFailOption) => {
        errorCb?.(aliJsFormatCommonFailMessage(res));
      }
    }),
    function () {
      successCb?.();
    }
  );
}

// 拍照或从手机相册中选择图片
export function aliJsChooseImage(
  option: chooseImageOption,
  successCb?: (res: chooseImageResult) => void,
  errorCb?: (message: string) => void
) {
  ap.chooseImage(
    Object.assign(option, {
      fail: (res: commonFailOption) => {
        errorCb?.(aliJsFormatCommonFailMessage(res, "chooseImage"));
      }
    }),
    function (res) {
      successCb?.(res);
    }
  );
}

// 预览图片
export function aliJsPreviewImage(
  option: previewImageOption,
  successCb?: () => void,
  errorCb?: (message: string) => void
) {
  ap.previewImage(
    Object.assign(option, {
      fail: (res: commonFailOption) => {
        errorCb?.(aliJsFormatCommonFailMessage(res));
      }
    }),
    function () {
      successCb?.();
    }
  );
}
